<template>
    <div class="c-step">
        <row-title>
            <template slot="heading">
                <h3>{{data.title}}</h3>

                <span>{{subtitle}}</span>
            </template>
        </row-title>

        <div class="c-step__body">
            <div
                class="c-step__part"
                v-for="(part, i) in data.rows"
                :key="i"
                v-show="i === activePart"
            >
                <row v-for="(data, index) in part" :key="index" :data="data"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from "vuex";
    import { formatCurrency } from "utils";

    import Title from "components/title/Title.vue";
    import Row from "components/row/Row.vue";

    export default {
        components: {
            "row-title": Title,
            row: Row
        },

        props: {
            data: {
                type: Object,
                required: true
            },

            stepIndex: {
                type: Number,
                required: true
            },

            activePart: {
                type: Number,
                required: true
            }
        },

        computed: {
            stepTotal() {
                const total = this.$store.getters.stepTotal(this.stepIndex);
                return isNaN(total) ? 0 : formatCurrency(total);
            },

            subtitle() {
                return `Part ${this.activePart + 1} of ${this.data.rows.length}`;
            },

            isLastPart() {
                return this.activePart === this.data.rows.length - 1;
            }
        },

        methods: {
            ...mapActions(["setStepMeta"])
        },

        created() {
            // prettier-ignore
            !this.$store.getters.steps.find(step => step.title === this.data.title) && this.setStepMeta({
                            title: this.data.title,
                            color: this.data.color
                        });
        }
    };
</script>

<style lang="scss" scoped>
    .c-step {
        &__body {
            min-height: 29.875rem;
        }

        &__total {
            text-align: right;
            font-size: 1.125rem;

            strong {
                font-size: 1.375rem;
            }
        }
    }
</style>
